// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api'; 

// /* ================= STYLED COMPONENTS ================= */
// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1200px, calc(100% - 32px));
//   margin: 90px auto 30px;
// `;

// const BackButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: none;
//   border: none;
//   color: #1d4ed8;
//   font-weight: 800;
//   font-size: 1.05rem;
//   cursor: pointer;
//   margin-bottom: 20px;
//   padding: 0;
//   transition: transform 0.2s ease, color 0.2s ease;

//   &:hover {
//     color: #1e3a8a;
//     transform: translateX(-4px);
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 28px;
//   margin-bottom: 22px;
//   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   font-size: 0.98rem;
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 24px;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const ColumnCard = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 22px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);
//   min-height: 500px;
//   display: flex;
//   flex-direction: column;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-size: 1.3rem;
//   font-weight: 800;
//   margin: 0 0 20px 0;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const CountBadge = styled.span`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: #e0ecff;
//   color: #1d4ed8;
//   font-size: 0.85rem;
// `;

// const SearchInput = styled.input`
//   width: 100%;
//   padding: 12px 16px;
//   border-radius: 12px;
//   border: 1px solid #cbd5e1;
//   background: #f8fafc;
//   font-size: 0.95rem;
//   margin-bottom: 20px;
//   transition: all 0.2s ease;

//   &:focus {
//     outline: none;
//     border-color: #3b82f6;
//     background: #fff;
//     box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
//   }
// `;

// const UserList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 12px;
//   overflow-y: auto;
//   max-height: 600px;
//   padding-right: 4px;

//   &::-webkit-scrollbar { width: 6px; }
//   &::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
// `;

// const UserCard = styled.div`
//   padding: 16px;
//   border: 1px solid #e2e8f0;
//   border-radius: 16px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: #fff;
//   transition: box-shadow 0.2s ease;

//   &:hover {
//     box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
//   }
// `;

// const UserInfo = styled.div`
//   h3 { margin: 0 0 4px; font-size: 1.05rem; color: #0f172a; }
//   p { margin: 0; font-size: 0.85rem; color: #64748b; }
// `;

// const ActionButton = styled.button`
//   padding: 8px 16px;
//   border-radius: 12px;
//   border: none;
//   font-weight: 700;
//   font-size: 0.9rem;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   white-space: nowrap;

//   background: ${({ variant, isAssigned }) => 
//     isAssigned ? '#f1f5f9' : variant === 'add' ? '#eff6ff' : '#fef2f2'};
//   color: ${({ variant, isAssigned }) => 
//     isAssigned ? '#94a3b8' : variant === 'add' ? '#1d4ed8' : '#dc2626'};

//   &:hover:not(:disabled) {
//     background: ${({ variant }) => variant === 'add' ? '#dbeafe' : '#fee2e2'};
//   }
  
//   &:disabled {
//     cursor: not-allowed;
//   }
// `;

// const EmptyState = styled.div`
//   text-align: center;
//   padding: 40px 20px;
//   color: #64748b;
//   font-size: 0.95rem;
//   background: #f8fafc;
//   border-radius: 12px;
//   border: 1px dashed #e2e8f0;
//   margin-top: auto;
//   margin-bottom: auto;
// `;

// const Message = styled.div`
//   background-color: ${({ type }) => (type === "error" ? "#fee2e2" : "#dcfce7")};
//   color: ${({ type }) => (type === "error" ? "#dc2626" : "#16a34a")};
//   padding: 14px 20px;
//   border-radius: 12px;
//   border: 1px solid ${({ type }) => (type === "error" ? "#f87171" : "#86efac")};
//   font-weight: 700;
//   margin-bottom: 20px;
//   text-align: center;
// `;

// const Spinner = styled.div`
//   width: 40px;
//   height: 40px;
//   margin: 40px auto;
//   border-radius: 50%;
//   border: 4px solid #e0ecff;
//   border-top-color: #1d4ed8;
//   animation: spin 0.8s linear infinite;

//   @keyframes spin {
//     to { transform: rotate(360deg); }
//   }
// `;

// /* ================= MAIN COMPONENT ================= */
// const ManageTeam = ({ user }) => {
//   const navigate = useNavigate();
  
//   const [allStaff, setAllStaff] = useState([]);
//   const [myTeam, setMyTeam] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(null); 
//   const [searchTerm, setSearchTerm] = useState("");

//   // Messaging state
//   const [successMsg, setSuccessMsg] = useState("");
//   const [errorMsg, setErrorMsg] = useState("");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Auto-clear messages
//   useEffect(() => {
//     if (successMsg || errorMsg) {
//       const timer = setTimeout(() => {
//         setSuccessMsg("");
//         setErrorMsg("");
//       }, 4000);
//       return () => clearTimeout(timer);
//     }
//   }, [successMsg, errorMsg]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const [allStaffRes, myTeamRes] = await Promise.all([
//         api.get('/auth/all-staff'),
//         api.get('/auth/my-team')
//       ]);

//       const myTeamData = myTeamRes.data.data;
//       const myTeamIds = myTeamData.map(staff => staff._id);

//       // Filter out 'my team' from the 'all staff' list
//       const otherStaffData = allStaffRes.data.data.filter(staff => !myTeamIds.includes(staff._id));

//       setAllStaff(otherStaffData);
//       setMyTeam(myTeamData);
//     } catch (error) {
//       setErrorMsg("Failed to fetch staff data. Please refresh the page.");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddStaff = async (staffId, staffName) => {
//     setActionLoading(staffId);
//     setErrorMsg("");
//     setSuccessMsg("");
//     try {
//       await api.put(`/auth/assign-staff/${staffId}`);
//       setSuccessMsg(`Successfully added ${staffName} to your team.`);
//       fetchData(); // Refreshes both lists
//     } catch (error) {
//       setErrorMsg("Failed to add staff member. Please try again.");
//     } finally {
//       setActionLoading(null);
//     }
//   };

//   const handleRemoveStaff = async (staffId, staffName) => {
//     if (!window.confirm(`Are you sure you want to remove ${staffName} from your team?`)) return;
    
//     setActionLoading(staffId);
//     setErrorMsg("");
//     setSuccessMsg("");
//     try {
//       await api.put(`/auth/remove-staff/${staffId}`);
//       setSuccessMsg(`Removed ${staffName} from your team.`);
//       fetchData();
//     } catch (error) {
//       setErrorMsg("Failed to remove staff member. Please try again.");
//     } finally {
//       setActionLoading(null);
//     }
//   };

//   // Filter Directory by search term
//   const filteredStaff = allStaff.filter(staff => 
//     `${staff.firstName} ${staff.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     (staff.unit || "").toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />
      
//       <PageWrapper>
//         {/* Navigation Back Button */}
//         <BackButton onClick={() => navigate('/supervisor/dashboard')}>
//           ← Back to Dashboard
//         </BackButton>

//         <HeroCard>
//           <div>
//             <HeroTitle>Manage Your Team</HeroTitle>
//             <HeroText>Browse the Department/Zone directory and add unassigned staff members to your timeline.</HeroText>
//           </div>
//         </HeroCard>

//         {/* Status Messages */}
//         {successMsg && <Message type="success">{successMsg}</Message>}
//         {errorMsg && <Message type="error">{errorMsg}</Message>}

//         <Grid>
//           {/* COLUMN 1: Department/Zone DIRECTORY */}
//           <ColumnCard>
//             <Title>
//               Department/Zone Directory
//               <CountBadge>{filteredStaff.length}</CountBadge>
//             </Title>
            
//             <SearchInput 
//               type="text" 
//               placeholder="Search by name or unit..." 
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />

//             {loading ? <Spinner /> : filteredStaff.length === 0 ? (
//               <EmptyState>No staff members found matching your search.</EmptyState>
//             ) : (
//               <UserList>
//                 {filteredStaff.map(staff => {
//                   const isAssigned = !!staff.supervisorId; 
//                   const staffFullName = `${staff.firstName} ${staff.surname}`;

//                   return (
//                     <UserCard key={staff._id}>
//                       <UserInfo>
//                         <h3>{staffFullName}</h3>
//                         <p>{staff.unit} | {staff.department || "No Dept"}</p>
//                       </UserInfo>
                      
//                       <ActionButton 
//                         variant="add" 
//                         isAssigned={isAssigned}
//                         onClick={() => handleAddStaff(staff._id, staffFullName)}
//                         disabled={isAssigned || actionLoading === staff._id}
//                       >
//                         {actionLoading === staff._id 
//                           ? "Adding..." 
//                           : isAssigned 
//                             ? "Assigned" 
//                             : "+ Add to Team"}
//                       </ActionButton>
//                     </UserCard>
//                   );
//                 })}
//               </UserList>
//             )}
//           </ColumnCard>

//           {/* COLUMN 2: MY TEAM */}
//           <ColumnCard>
//             <Title>
//               My Current Team
//               <CountBadge>{myTeam.length}</CountBadge>
//             </Title>
            
//             {loading ? <Spinner /> : myTeam.length === 0 ? (
//               <EmptyState>You have not added any staff to your team yet.</EmptyState>
//             ) : (
//               <UserList>
//                 {myTeam.map(staff => {
//                   const staffFullName = `${staff.firstName} ${staff.surname}`;
//                   return (
//                     <UserCard key={staff._id}>
//                       <UserInfo>
//                         <h3>{staffFullName}</h3>
//                         <p>{staff.unit} | {staff.department || "No Dept"}</p>
//                       </UserInfo>
//                       <ActionButton 
//                         variant="remove" 
//                         onClick={() => handleRemoveStaff(staff._id, staffFullName)}
//                         disabled={actionLoading === staff._id}
//                       >
//                         {actionLoading === staff._id ? "Removing..." : "Remove"}
//                       </ActionButton>
//                     </UserCard>
//                   );
//                 })}
//               </UserList>
//             )}
//           </ColumnCard>
//         </Grid>
//       </PageWrapper>
//       <Footer />
//     </AppContainer>
//   );
// };

// export default ManageTeam;

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api'; 

/* ================= STYLED COMPONENTS ================= */
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
`;

const PageWrapper = styled.div`
  flex: 1 0 auto;
  width: min(800px, calc(100% - 32px)); /* Narrower width for centering */
  margin: 100px auto 60px; /* Centered with margin */
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #1d4ed8;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 24px;
  padding: 8px 0;
  transition: all 0.2s ease;

  &:hover {
    color: #1e3a8a;
    transform: translateX(-4px);
  }
`;

const TeamCard = styled.div`
  background: white;
  border-radius: 32px;
  padding: 40px;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.8);
  
  @media (max-width: 576px) {
    padding: 24px;
    border-radius: 24px;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

const Title = styled.h1`
  color: #0f172a;
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const Subtitle = styled.p`
  color: #64748b;
  font-size: 1.1rem;
  margin: 0;
`;

const CountBadge = styled.span`
  font-size: 0.9rem;
  padding: 4px 16px;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 999px;
  font-weight: 700;
  border: 1px solid #dbeafe;
`;

const SearchBox = styled.div`
  margin-bottom: 30px;
  position: relative;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 14px 20px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 1rem;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.08);
  }
`;

const UserList = styled.div`
  display: grid;
  gap: 16px;
`;

const UserCard = styled.div`
  padding: 20px;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  transition: all 0.3s ease;

  &:hover {
    border-color: #cbd5e1;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.02);
  }
`;

const Avatar = styled.div`
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.2rem;
  flex-shrink: 0;
`;

const UserInfo = styled.div`
  flex: 1;
  h3 { 
    margin: 0 0 2px; 
    font-size: 1.15rem; 
    color: #0f172a; 
    font-weight: 700;
  }
  p { 
    margin: 0; 
    font-size: 0.9rem; 
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

const UnitTag = styled.span`
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 24px;
  border: 2px dashed #e2e8f0;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  margin: 60px auto;
  border-radius: 50%;
  border: 4px solid #e0ecff;
  border-top-color: #1d4ed8;
  animation: spin 1s linear infinite;
  @keyframes spin { to { transform: rotate(360deg); } }
`;

/* ================= MAIN COMPONENT ================= */
const ManageTeam = ({ user }) => {
  const navigate = useNavigate();
  const [myTeam, setMyTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    try {
      setLoading(true);
      const res = await api.get('/auth/my-team');
      setMyTeam(res.data.data);
    } catch (error) {
      console.error("Error fetching team:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredTeam = myTeam.filter(staff => 
    `${staff.firstName} ${staff.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (staff.unit || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AppContainer>
      <NavBarSuper user={user} />
      
      <PageWrapper>
        <BackButton onClick={() => navigate('/supervisor/dashboard')}>
          ← Back to Dashboard
        </BackButton>

        <TeamCard>
          <Header>
            <Title>
              My Team <CountBadge>{myTeam.length}</CountBadge>
            </Title>
            <Subtitle>Manage and view members reporting directly to you</Subtitle>
          </Header>

          <SearchBox>
            <SearchInput 
              type="text" 
              placeholder="Search team members by name or unit..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBox>
            
          {loading ? (
            <Spinner />
          ) : filteredTeam.length === 0 ? (
            <EmptyState>
              {searchTerm 
                ? "No team members match your search." 
                : "Your team is currently empty."}
            </EmptyState>
          ) : (
            <UserList>
              {filteredTeam.map(staff => {
                const initials = `${staff.firstName?.[0] || ''}${staff.surname?.[0] || ''}`;
                return (
                  <UserCard key={staff._id}>
                    <Avatar>{initials}</Avatar>
                    <UserInfo>
                      <h3>{staff.firstName} {staff.surname}</h3>
                      <p>
                        {staff.department || "No Department"} 
                        <UnitTag>{staff.unit || "General"}</UnitTag>
                      </p>
                    </UserInfo>
                  </UserCard>
                );
              })}
            </UserList>
          )}
        </TeamCard>
      </PageWrapper>
      
      <Footer />
    </AppContainer>
  );
};

export default ManageTeam;